import { render } from "./GarantePayDataTable.vue?vue&type=template&id=2c78bbee&scoped=true"
import script from "./GarantePayDataTable.vue?vue&type=script&lang=js"
export * from "./GarantePayDataTable.vue?vue&type=script&lang=js"

import "./GarantePayDataTable.vue?vue&type=style&index=0&id=2c78bbee&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c78bbee"]])

export default __exports__